import useApi from './useApi';

const useExtraService = () => {
  const { api } = useApi();

  // Extras managment

  const getAllExtras = () => api({
    method: 'get',
    url: '/product-marketing/v1/establishments/own/extras',
  });

  const getExtra = (extraId) => api({
    method: 'get',
    url: `/product-marketing/v1/establishments/own/extras/${extraId}`,
  });

  const postExtra = (extra) => api({
    method: 'post',
    url: '/product-marketing/v1/establishments/own/extras',
    data: extra,
  });

  const putExtra = ({ extraId, extra }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/extras/${extraId}`,
    data: extra,
  });

  const putExtraTranslations = ({ extraId, langCode, translations }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/extras/${extraId}/translations/${langCode}`,
    data: translations,
  });

  // Static data

  const getExtraTypes = () => api({
    method: 'get',
    url: '/product-marketing/v1/extra-types',
  });

  return {
    getAllExtras,
    getExtra,
    postExtra,
    putExtra,
    putExtraTranslations,
    getExtraTypes,
  };
};

export default useExtraService;
